import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Download, ShieldCheck } from 'lucide-react';
export const FinalCtaSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-brand-warmcream text-center" data-id="element-27">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-emerald leading-tight mb-8" data-id="element-30">
            Tu cuerpo no está roto.
            <br data-id="element-31" />
            <span className="text-brand-emerald" data-id="element-32">
              Solo necesita las instrucciones correctas.
            </span>
          </h2>

          <p className="text-xl text-brand-charcoal mb-12 max-w-2xl mx-auto" data-id="element-33">
            Más de 21 días de método comprobado en tus manos hoy — por menos del
            precio de un café.
          </p>

          <a href="https://go.hotmart.com/L105883257P" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto px-10 py-5 text-xl font-bold text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 mb-6" data-id="element-34">
            QUIERO MI GUÍA AHORA — $9.99
          </a>

          <p className="italic text-center mx-auto mt-2 mb-8" style={{
          fontSize: '12px',
          color: '#6B7280',
          maxWidth: '500px'
        }} data-id="element-35">
            ⚕️ El contenido de esta guía es informativo y educativo. No
            reemplaza ni sustituye el consejo, diagnóstico o tratamiento médico
            profesional. Consulta siempre a tu médico ante cualquier duda sobre
            tu salud.
          </p>

          <div className="flex flex-wrap justify-center gap-6 sm:gap-10 text-sm font-medium text-gray-600" data-id="element-36">
            <div className="flex items-center gap-2" data-id="element-37">
              <Lock className="w-5 h-5" data-id="element-38" />
              <span data-id="element-39">Pago Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-40">
              <Download className="w-5 h-5" data-id="element-41" />
              <span data-id="element-42">Descarga Inmediata</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-43">
              <ShieldCheck className="w-5 h-5" data-id="element-44" />
              <span data-id="element-45">Basado en Ciencia</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};